module.exports = __webpack_public_path__ + "img/efecty.5191db8b.svg";